import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { LoadingContainer } from "go-core/components/Loading";
import { adminApi } from "../../../../../../services/Api/Admin/adminApi";
import { OrganizationApi, OrganizationFeatureApi, UserRole } from "../../../../../../services/Api/types";
import OrganizationFeaturesTableForm from "../../../Organization/OrganizationFeaturesTableForm";
import { OrganizationPreviewRequests } from "../services/types";

interface Props {
	onSuccess: () => void;
	onHide: () => void;
	isShown: boolean;
	organization: OrganizationApi;
	context: string;
	requests: OrganizationPreviewRequests;
	areAllowed: (contexts: Record<string, UserRole[]>) => boolean;
}

const OrganizationFeaturesEditModal = (props: Props) => {
	const { t } = useTranslation("admin");
	const [features, setFeatures] = useState<OrganizationFeatureApi[] | undefined>();
	const [info, setInfo] = useState<any | undefined>();
	const { addFlash } = useFlash();
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		fetch();
	}, []);

	const fetch = async () => {
		setLoading(true);
		await Promise.all([featchFeatures(), fetchInfo()]);
		setLoading(false);
	};

	const featchFeatures = async () => {
		if (!props.requests.getFeatures) return;
		try {
			const res = await props.requests.getFeatures(props.organization.id);
			setFeatures(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	const fetchInfo = async () => {
		try {
			const res = await adminApi.getOrganizationFeaturesInfo(Number(props.organization.id));
			setInfo(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	return (
		<Modal show={props.isShown} onHide={props.onHide} className={"modal-lg"}>
			<Modal.Header closeButton>
				{/*<Modal.Title>{t("components.organization_merging_modal.header.title")}</Modal.Title>*/}
				<Modal.Title>Edycja funkcji</Modal.Title>
			</Modal.Header>
			{loading ? (
				<LoadingContainer />
			) : (
				<>
					{features ? (
						<OrganizationFeaturesTableForm
							features={features}
							organization={props.organization}
							info={info}
							context={props.context}
							requests={props.requests}
							onSuccess={props.onSuccess}
							onHide={props.onHide}
							areAllowed={props.areAllowed}
						/>
					) : (
						<></>
					)}
				</>
			)}
		</Modal>
	);
};
export default OrganizationFeaturesEditModal;
